<template>
  <v-container fluid class="pa-0">
    <!--app-bar-->
    <v-app-bar flat color="red-darken-3">
      <v-app-bar-title class="hidden-sm-and-down">
        {{ $t("repositories.label") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
      <v-text-field
        v-model="search"
        :label="$t('repositories.search')"
        flat
        variant="solo"
        color="red-darken-1"
        append-inner-icon="mdi-magnify"
        single-line
        hide-details
        density="compact"
        class="repositories-search-field ml-1"
      />
      <v-btn
        v-if="
          $store.getters.role == 'LekoAdmin' ||
          $store.getters.role == 'InstitutionAdmin' ||
          $store.getters.role == 'InstitutionManager' ||
          $store.getters.role == 'SuperAdmin'
        "
        class="d-md-none repositories-new-btn"
        color="grey-darken-4"
        variant="flat"
        size="small"
        @click="newRepository"
      >
        {{ $t("repositories.button") }}
        <v-icon end>mdi-plus</v-icon>
      </v-btn>
      <v-spacer class="hidden-sm-and-down" />
      <!-- POPULATE FOR DEMO ACC -->
      <v-btn
        v-if="$store.getters.role == 'SuperAdmin'"
        class="d-none d-md-inline-flex"
        @click="openPopulate"
      >
        <v-icon left> fas fa-plus </v-icon>
        populate
      </v-btn>
      <v-btn
        v-if="
          $store.getters.role == 'LekoAdmin' ||
          $store.getters.role == 'InstitutionAdmin' ||
          $store.getters.role == 'InstitutionManager' ||
          $store.getters.role == 'SuperAdmin'
        "
        color="grey-darken-4"
        variant="flat"
        class="d-none d-md-inline-flex"
        @click="newRepository"
      >
        {{ $t("repositories.button") }}
        <v-icon end> mdi-plus </v-icon>
      </v-btn>

     
    </v-app-bar>

    <!--ALERT-->
    <v-alert
      :model-value="alert.value"
      type="error"
      variant="tonal"
      border="bottom"
    >
      {{ alert.message }}
    </v-alert>
    <v-dialog v-model="populateModal" max-width="500">
      <v-card class="pa-3">
        <div class="ml-2 mb-2">Choose an institution to add locations.</div>
        <div>
          <v-autocomplete
            v-model="institution"
            :items="displayedInstitutions"
            :loading="loadingInstitution"
            :label="$t('parts.advanced_search.institution')"
            persistent-hint
            item-title="title"
            item-value="_id"
            variant="solo"
            color="red-darken-1"
            class="ml-2 mr-2 pt-2"
            clearable
          />
        </div>
        <div class="col-12 text-end d-flex ml-auto">
          <v-btn
            :disabled="!institution"
            color="red-darken-3"
            class="white--text"
            @click="populate"
          >
            populate
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <!--ALERT DIALOG-->
    <alert-dialog
      ref="alert"
      @confirmed="operationConfirmed"
      @cancelled="operationCancelled"
    />

    <!--DETAILS-->
    <details-dialog ref="detailsDialog" @shelves="viewShelves" />
    <!--SHELVES-->
    <shelves ref="shelves" @parts="viewParts" @close="viewDetails(__details)" />
    <!--PARTS-->
    <parts ref="parts" @close="viewShelves(__shelves)" />
    <!--EDIT DIALOG-->
    <edit-dialog
      ref="editDialog"
      @location="openSEditDialog"
      @save="getRepositories"
      @remove-room="confirmRemoveRoom"
      @remove-location="confirmRemoveLocation"
    />
    <!--SECONDARY EDIT DIALOG-->
    <s-edit-dialog
      ref="sEditDialog"
      @close="closeSEditDialog"
      @save="closeSEditDialog"
    />
    <!--DATATABLE-->
    <datatable
      ref="datatable"
      :search="search"
      @details="viewDetails"
      @edit="editRepository"
      @delete="confirmRepositoryDelete"
    />
  </v-container>
</template>

<script>
import Details from "@/components/Repositories/details.vue";
import Shelves from "@/components/Repositories/shelves.vue";
import Parts from "@/components/Repositories/parts.vue";
import EditDialog from "@/components/Repositories/editDialog.vue";
import SEditDialog from "@/components/Repositories/sEditDialog.vue";
import Datatable from "@/components/Repositories/datatable.vue";
import AlertDialog from "@/components/alert.vue";

import deleteRequest from "../api/deleteRequest";
import postRequest from "../api/postRequest";
import getRequest from "../api/getRequest";

export default {
  components: {
    "details-dialog": Details,
    shelves: Shelves,
    parts: Parts,
    "edit-dialog": EditDialog,
    "s-edit-dialog": SEditDialog,
    "alert-dialog": AlertDialog,
    datatable: Datatable,
  },
  data: () => ({
    search: "",
    alert: {
      value: false,
      message: "",
    },
    __details: null,
    __shelves: null,
    __editDialogData: null,
    __hideDetails: false, // Used to prevent opening details dialog when viewing parts.
    allowedInstitutions: [
      "686540c3a99dd439285ff063",
      "687de0e83d1b82a6724f89b0",
      // add more IDs here
    ],
    populateModal: false,
    institution: "",
    displayedInstitutions: [],
    loadingInstitution: false,
  }),
  watch: {
    search(value) {
      const { datatable } = this.$refs;
      datatable.search(value);
    },
  },
  mounted() {},
  created() {
    this.getInstitutions();
  },
  methods: {
    showAlert(message) {
      this.alert = {
        value: true,
        message,
      };
      setTimeout(() => {
        this.alert.value = false;
      }, 2000);
    },
    getRepositories() {
      const { datatable } = this.$refs;
      datatable.getRepositories();
    },
    newRepository() {
      const { editDialog } = this.$refs;
      editDialog.open(false, {});
    },
    editRepository(data) {
      const { editDialog } = this.$refs;
      editDialog.open(true, data);
    },
    confirmRepositoryDelete(id) {
      const { alert } = this.$refs;
      alert.open({ op: "deleteRepository", id });
    },
    confirmRemoveRoom(index) {
      const { alert } = this.$refs;
      const { editDialog } = this.$refs;
      editDialog.hide();
      alert.open({ op: "removeRoom", index });
    },
    confirmRemoveLocation(index) {
      const { alert } = this.$refs;
      const { editDialog } = this.$refs;
      editDialog.hide();
      alert.open({ op: "removeLocation", index });
    },
    operationConfirmed(data) {
      const { alert } = this.$refs;
      const { editDialog } = this.$refs;
      if (data.op && data.op === "deleteRepository") {
        deleteRequest("/repository", `id=${data.id}`)
          .then((response) => {
            alert.close();
            this.getRepositories();
          })
          .catch((error) => {
            if (error.response.status === 403)
              this.showAlert(this.$t("repositories.not_empty"));
            alert.close();
          });
      } else if (data.op && data.op === "removeRoom") {
        editDialog.removeRoom(data.index);
        alert.close();
        editDialog.show();
      } else if (data.op && data.op === "removeLocation") {
        editDialog.removeLocation(data.index);
        alert.close();
        editDialog.show();
      }
    },
    operationCancelled(data) {
      if (
        data.op &&
        (data.op === "removeRoom" || data.op === "removeLocation")
      ) {
        const { editDialog } = this.$refs;
        editDialog.show();
      }
    },
    openSEditDialog(data) {
      const { editDialog } = this.$refs;
      const { sEditDialog } = this.$refs;
      this.__editDialogData = data;
      editDialog.close();
      sEditDialog.open(data);
    },
    closeSEditDialog(data) {
      const { editDialog } = this.$refs;
      if (data.saved) {
        editDialog.open(true, data.editedRepository);
      } else {
        editDialog.open(true, this.__editDialogData.repository);
      }
      editDialog.selectRoom(this.__editDialogData.room.index);
      this.__editDialogData = null;
    },
    viewDetails(data) {
      if (!this.__hideDetails) {
        this.__details = data;
        const { detailsDialog } = this.$refs;
        detailsDialog.open(data);
      }
    },
    viewShelves(data) {
      this.__shelves = data;
      this.__hideDetails = false;
      const { shelves } = this.$refs;
      const { detailsDialog } = this.$refs;
      detailsDialog.close();
      shelves.open(data);
    },
    viewParts(data) {
      const { parts } = this.$refs;
      const { shelves } = this.$refs;
      this.__hideDetails = true;
      shelves.close();
      parts.open(data);
    },
    async populate() {
      try {
        // const { institutionId } = this.$store.getters;
        const response = await postRequest.object(
          `/demo/populate-locations?institution_id=${this.institution}`,
          null,
        );
        if (response) {
          this.getRepositories();
          this.closePopulate();
        }
      } catch {
        this.closePopulate();
      }
    },
    openPopulate() {
      this.populateModal = true;
    },
    closePopulate() {
      this.populateModal = false;
      this.institution_id = "";
    },
    getInstitutions() {
      this.loadingInstitution = true;
      getRequest("/institution/")
        .then((response) => {
          if (response && response.institutions) {
            this.displayedInstitutions = response.institutions;
          }
          this.loadingInstitution = false;
        })
        .catch(() => {
          this.loadingInstitution = false;
        });
    },
  },
};
</script>

<style>
.repositories-search-field {
  min-width: 160px;
  max-width: 560px;
}

@media (max-width: 959.98px) {
  .repositories-search-field {
    max-width: 210px;
    margin-right: 8px;
  }
  .repositories-new-btn {
    white-space: nowrap;
  }
}
</style>
